export const GRAPH_URL: Record<number, string> = {
  1: 'https://api.goldsky.com/api/public/project_clge2hwmi0ia04au579q1eh70/subgraphs/kali-mainnet/1.0.1/gn',
  42161: 'https://api.goldsky.com/api/public/project_clge2hwmi0ia04au579q1eh70/subgraphs/kali-arbitrum/1.0.1/gn',
  137: 'https://api.goldsky.com/api/public/project_clge2hwmi0ia04au579q1eh70/subgraphs/kali-matic/1.0.2/gn',
  10: 'https://api.goldsky.com/api/public/project_clge2hwmi0ia04au579q1eh70/subgraphs/kali-optimism/1.0.2/gn'
}
